import { BasePaginationDto } from '@@types/api.types';
import { Button } from '@components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@components/ui/select';
import React from 'react';

type IntelTechnologiesPaginationProps = {
  isFetching: boolean;
  onPageChange: (page: number) => void;
  onPageSizeChange: (limit: number) => void;
  pagination: BasePaginationDto;
};

const PAGE_SIZE_OPTIONS = [25, 50, 100];

export const IntelTechnologiesPagination: React.FC<IntelTechnologiesPaginationProps> = (props) => {
  const { isFetching, onPageChange, onPageSizeChange, pagination } = props;

  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div className="flex items-center gap-2 text-xs text-gray-500">
        {pagination.totalItems > 0 && (
          <span>
            Showing {(pagination.page - 1) * pagination.limit + 1} to{' '}
            {Math.min(pagination.page * pagination.limit, pagination.totalItems)} of {pagination.totalItems}{' '}
            technologies
          </span>
        )}
      </div>

      <div className="flex items-center gap-3">
        <Select
          value={String(pagination.limit)}
          onValueChange={(value) => onPageSizeChange(Number(value))}
        >
          <SelectTrigger className="w-[140px]">
            <SelectValue placeholder="Page size" />
          </SelectTrigger>
          <SelectContent>
            {PAGE_SIZE_OPTIONS.map((option) => (
              <SelectItem
                key={option}
                value={String(option)}
              >
                {option} per page
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <div className="flex items-center gap-2">
          <Button
            disabled={isFetching || !pagination.hasPreviousPage}
            onClick={() => onPageChange(pagination.page - 1)}
            type="button"
            variant="outline"
          >
            Previous
          </Button>
          <Button
            disabled={isFetching || !pagination.hasNextPage}
            onClick={() => onPageChange(pagination.page + 1)}
            type="button"
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};
